/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pace_Est_DistanceInputs */

const en_ui_pace_est_distance = /** @type {(inputs: Ui_Pace_Est_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Race Distance`)
};

const de_ui_pace_est_distance = /** @type {(inputs: Ui_Pace_Est_DistanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wettkampfdistanz`)
};

/**
* | output |
* | --- |
* | "Race Distance" |
*
* @param {Ui_Pace_Est_DistanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pace_est_distance = /** @type {((inputs?: Ui_Pace_Est_DistanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pace_Est_DistanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pace_est_distance(inputs)
	return de_ui_pace_est_distance(inputs)
});